import { Anchor, Flex, Group, Paper, Stack, Text } from "@mantine/core";
import { useSessionStore } from "../../../../../stores/UserStore";
import APIKeyListing from "./APIKeyListing";
import AddApiKey from "./AddApiKey";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { useState } from "react";

const API = () => {
  const lang = useLanguage((s) => s.language);

  const [loading, setLoading] = useState(true);
  return (
    <>
      <Paper component={Group} p={"lg"} mt={16} wrap="nowrap" gap={"xl"}>
        <Stack w={"50%"}>
          <Text fw={600} size="lg">
            {lang.settings.api_title}{" "}
            {useSessionStore.getState().reseller?.name}
          </Text>

          <Text>
            {lang.settings.api_text1}{" "}
            <Anchor
              href={`https://${
                useSessionStore.getState()?.reseller?.domain_api ||
                "app.api-magileads.net"
              }`}
              target="_blank"
            >
              {lang.settings.api_text2}
            </Anchor>{" "}
            {lang.settings.api_text3}
          </Text>
        </Stack>
        <AddApiKey onFinish={() => setLoading(true)}  ml="auto" />
      </Paper>

      <Text fw={600} size="lg" mt={32}>
        {lang.settings.your_api} {useSessionStore.getState().reseller?.name}
      </Text>

      <Flex flex={1}>
        <APIKeyListing loading={loading} setLoading={setLoading} />
      </Flex>
    </>
  );
};

export default API;
